import React, { Component }from "react";
import Row from "reactstrap/lib/Row";
import  { Col } from "reactstrap/lib";
import { Button } from 'reactstrap';
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setLoader } from "../../../actions/action-creators";
import moment from "moment";
import UserCard from "./user_card";


class UserReferrals extends Component {
    constructor(props) {
        super(props);
        this.state = {
            referralData : [],
        }
    }

    componentDidMount(){
        this.fetchReferral();
    }

    fetchReferral = async () => {
        store.dispatch(setLoader(true))
        try{
            var body = { referred_by : this.props.user_id }
            let resp = await ApiEndpoints.Referral.fetchReferralDetails(body)
            let referralData = resp.data.data
            this.setState({ referralData })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }

      
    
    render() {
        let { referralData } = this.state;
        return (
            <div className="px-1">
               
                {referralData.length ? referralData.map(referral => 
                        <Row style={{fontSize: 14, borderRadius: 12}} className="bg-light border align-items-center py-1 my-2" >
                            <Col xs={7}>
                                <UserCard data={referral.user} />
                            </Col>
                            <Col xs={5} className="text-right">
                                <strong className="d-block">{referral.status_text}</strong>
                                <span className="px-2 small">{moment(referral.created_on).utcOffset("+05:30").format("Do MMM'YY")}</span>
                            </Col>
                        </Row>
                ) : <em className="m-4 text-secondary d-block">No referral data</em> }
                     
                   
            </div>
           
        );
    }
}
export default UserReferrals;

const BANK_STATUS = {
    0: {
        label: "Pending",
        color: "#666"
    },
    1: {
        label: "Verified",
        color: "#090"
    },
    2: {
        label: "Rejected",
        color: "#d00"
    }
}